/*
 * @Description: 
 * @Author: weig
 * @Date: 2021-06-11 15:54:16
 * @LastEditors: weig
 * @LastEditTime: 2021-12-17 11:22:08
 */
import request from '../../utils/request'
import EnumConfig from '../../enum/EnumConfig'

var CURR_API_VERSION = EnumConfig.EnumConfig.API_VIEW_VERSION.CURR_API_VIEW_VERSION;
var API_VERSION = CURR_API_VERSION == 'V0' ? '' : `/S/${CURR_API_VERSION}`;

//获取支付列表信息
export const GetPageIncome = (params)=>{
    return request.apiGet(`/api${API_VERSION}/Pay/Pay/GetPageIncome`, params);
}
//获取支付信息
export const GetPayInfo = (params)=>{
    return request.apiPost(`/api${API_VERSION}/Pay/Pay/GetPayInfo`, params);
}
